import { useToast as useToastAdminUI } from '@vtex/admin-ui'

const TOAST_DURATION = 3000

export function useToast() {
  const showToast = useToastAdminUI()

  const errorToast = (message: string, key?: string) => {
    showToast({
      message,
      variant: 'critical',
      key: key ?? 'error-toast',
      duration: TOAST_DURATION,
    })
  }

  const warningToast = (message: string, key?: string) => {
    showToast({
      message,
      variant: 'warning',
      key: key ?? 'warning-toast',
      duration: TOAST_DURATION,
    })
  }

  const infoToast = (message: string, key?: string) => {
    showToast({
      message,
      variant: 'info',
      key: key ?? 'info-toast',
      duration: TOAST_DURATION,
    })
  }

  const positiveToast = (message: string, key?: string) => {
    showToast({
      message,
      variant: 'positive',
      key: key ?? 'positive-toast',
      duration: TOAST_DURATION,
    })
  }

  return {
    errorToast,
    warningToast,
    infoToast,
    positiveToast,
  }
}
